<div class="ts-landing" [class.ts-modal-open]="showAuthModal">
    <section class="ts-hero">
        <div class="ts-hero-inner">
            <div class="ts-hero-brand">
                <img
                    *ngIf="!logoLoadFailed"
                    class="ts-logo"
                    src="assets/public/images/mainlogo_lg.png"
                    alt="TruthShorts"
                    (error)="onLogoError()"
                />
                <div *ngIf="logoLoadFailed" class="ts-logo ts-logo-text-fallback" aria-label="TruthShorts">TruthShorts</div>
                <h1 class="ts-headline">
                    Truth <span class="ts-accent">For Freedom</span>
                </h1>
                <p class="ts-sub">Real voices. Real truth. No noise.</p>
            </div>

            <div class="ts-hero-auth" *ngIf="!showAuthModal">
                <div class="ts-auth-stack">
                    <p class="ts-auth-section-label">Continue with Google</p>
                    <div #googleBtnHero class="ts-google-host"></div>
                    <p *ngIf="googleBusy" class="ts-hint">Signing in with Google…</p>

                    <div class="ts-or">
                        <span>or sign in with email</span>
                    </div>

                    <input
                        type="email"
                        class="ts-input"
                        placeholder="Email"
                        [(ngModel)]="email"
                        name="heroEmail"
                        autocomplete="username"
                    />
                    <input
                        type="password"
                        class="ts-input"
                        placeholder="Password"
                        [(ngModel)]="password"
                        name="heroPassword"
                        autocomplete="current-password"
                        (keydown.enter)="login()"
                    />
                    <div *ngIf="errorMessage" class="ts-alert">{{ errorMessage }}</div>
                    <button type="button" class="ts-btn-primary" [disabled]="loginBusy" (click)="login()">
                        {{ loginBusy ? 'Please wait…' : 'Log In' }}
                    </button>
                    <div class="ts-center">
                        <button type="button" class="ts-link">Forgot Password?</button>
                    </div>
                    <div class="ts-center">
                        <button type="button" class="ts-btn-secondary" (click)="openCreateModal()">Create Account</button>
                    </div>
                    <div class="ts-center ts-mt-sm">
                        <button type="button" class="ts-link" (click)="openSignInModal()">Sign in</button>
                    </div>
                </div>
            </div>
        </div>
    </section>

    <section class="ts-trending">
        <div class="ts-trending-inner">
            <div class="ts-trending-title">
                <svg class="ts-trend-ico" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                    <polyline points="23 6 13.5 15.5 8.5 10.5 1 18" />
                    <polyline points="17 6 23 6 23 12" />
                </svg>
                <h2>Trending Now</h2>
            </div>
            <p *ngIf="trendingLoading" class="ts-muted">Loading trending…</p>
            <p *ngIf="trendingError" class="ts-alert">{{ trendingError }}</p>
            <div class="ts-trend-grid" *ngIf="!trendingLoading && trending.length">
                <app-trending-post-card *ngFor="let p of trending" [post]="p"></app-trending-post-card>
            </div>
        </div>
    </section>

    <footer class="ts-footer">
        <div class="ts-footer-inner">
            <div class="ts-muted">&copy; {{ copyrightYear }} TruthShorts. All rights reserved.</div>
            <div class="ts-footer-links">
                <a href="#">About</a>
                <a routerLink="/privacy">Privacy Policy</a>
                <a routerLink="/tos">Terms of Service</a>
                <a href="#">Advertising</a>
            </div>
        </div>
    </footer>
</div>

<div class="ts-overlay" *ngIf="showAuthModal" (click)="closeAuthModal()"></div>
<div class="ts-modal" *ngIf="showAuthModal" role="dialog" aria-modal="true" (click)="$event.stopPropagation()">
    <button type="button" class="ts-modal-close" (click)="closeAuthModal()" aria-label="Close">&times;</button>

    <ng-container *ngIf="!googleUsernameStep">
        <p class="ts-auth-section-label ts-auth-section-label-modal">Continue with Google</p>
        <div #googleBtnModal class="ts-google-host ts-google-host-modal"></div>
        <p *ngIf="googleBusy && !googleUsernameStep" class="ts-hint">Signing in with Google…</p>
        <div *ngIf="createErrors['google']" class="ts-alert">{{ createErrors['google'] }}</div>

        <div class="ts-or ts-or-uppercase">
            <span>or {{ authModalTab === 'create' ? 'create with email' : 'sign in with email' }}</span>
        </div>

        <div class="ts-modal-head">
            <h2>{{ authModalTab === 'create' ? 'Create Account' : 'Sign In' }}</h2>
            <p class="ts-muted" *ngIf="authModalTab === 'create'">Join the conversation. Speak truth.</p>
            <p class="ts-muted" *ngIf="authModalTab === 'signIn'">Welcome back.</p>
        </div>

        <ng-container *ngIf="authModalTab === 'signIn'">
            <div class="ts-field">
                <label>Email</label>
                <input type="email" class="ts-input-modal" [(ngModel)]="email" autocomplete="username" />
            </div>
            <div class="ts-field">
                <label>Password</label>
                <input type="password" class="ts-input-modal" [(ngModel)]="password" autocomplete="current-password" />
            </div>
            <div *ngIf="errorMessage" class="ts-alert">{{ errorMessage }}</div>
            <button type="button" class="ts-btn-primary" [disabled]="loginBusy" (click)="loginFromModal()">
                {{ loginBusy ? 'Please wait…' : 'Log In' }}
            </button>
            <p class="ts-modal-foot">
                No account?
                <button type="button" class="ts-link-bold" (click)="switchModalTab('create')">Create Account</button>
            </p>
        </ng-container>

        <form *ngIf="authModalTab === 'create'" (submit)="submitCreateAccount($event)">
            <div class="ts-field">
                <label>Email</label>
                <input
                    type="email"
                    class="ts-input-modal"
                    [(ngModel)]="createEmail"
                    (ngModelChange)="validateCreateField('email', $event)"
                    placeholder="you@example.com"
                    name="cEmail"
                />
                <div *ngIf="createErrors['email']" class="ts-val-err">{{ createErrors['email'] }}</div>
            </div>
            <div class="ts-field">
                <label>Username</label>
                <div class="ts-input-prefix-wrap">
                    <span class="ts-prefix">&#64;</span>
                    <input
                        type="text"
                        class="ts-input-modal ts-input-prefixed"
                        [(ngModel)]="createUsername"
                        (ngModelChange)="validateCreateField('username', $event)"
                        placeholder="your_handle"
                        name="cUser"
                    />
                </div>
                <div *ngIf="createErrors['username']" class="ts-val-err">{{ createErrors['username'] }}</div>
            </div>
            <div class="ts-field">
                <label>Display Name</label>
                <input type="text" class="ts-input-modal" [(ngModel)]="createDisplayName" placeholder="John Doe" name="cDisp" />
            </div>
            <div class="ts-field">
                <label>Password</label>
                <div class="ts-password-wrap">
                    <input
                        [type]="createShowPassword ? 'text' : 'password'"
                        class="ts-input-modal"
                        [(ngModel)]="createPassword"
                        (ngModelChange)="validateCreateField('password', $event)"
                        placeholder="Min. 8 characters"
                        name="cPass"
                    />
                    <button type="button" class="ts-eye" (click)="createShowPassword = !createShowPassword" tabindex="-1">
                        {{ createShowPassword ? 'Hide' : 'Show' }}
                    </button>
                </div>
                <div *ngIf="createErrors['password']" class="ts-val-err">{{ createErrors['password'] }}</div>
            </div>
            <div *ngIf="createErrors['form']" class="ts-alert">{{ createErrors['form'] }}</div>
            <button type="submit" class="ts-btn-primary" [disabled]="createBusy">
                {{ createBusy ? 'Please wait…' : 'Create Account' }}
            </button>
            <p class="ts-modal-foot">
                Already have an account?
                <button type="button" class="ts-link-bold" (click)="switchModalTab('signIn')">Sign In</button>
            </p>
        </form>
    </ng-container>

    <ng-container *ngIf="googleUsernameStep">
        <div class="ts-modal-head">
            <h2>Choose a username</h2>
            <p class="ts-muted">Your Google account ({{ googlePrefillEmail }}) is new here. Pick a unique handle.</p>
        </div>
        <div class="ts-field">
            <label>Display name from Google</label>
            <input type="text" class="ts-input-modal" [value]="googleSuggestProfile" readonly />
        </div>
        <div class="ts-field">
            <label>Username</label>
            <div class="ts-input-prefix-wrap">
                <span class="ts-prefix">&#64;</span>
                <input
                    type="text"
                    class="ts-input-modal ts-input-prefixed"
                    [(ngModel)]="createUsername"
                    (ngModelChange)="validateCreateField('username', $event)"
                    name="gUser"
                />
            </div>
            <div *ngIf="createErrors['username']" class="ts-val-err">{{ createErrors['username'] }}</div>
        </div>
        <button type="button" class="ts-btn-primary" [disabled]="googleBusy" (click)="submitGoogleUsername()">
            {{ googleBusy ? 'Please wait…' : 'Continue' }}
        </button>
        <button type="button" class="ts-btn-secondary ts-mt" (click)="exitGoogleUsernameStep()">Back</button>
    </ng-container>
</div>
